import { c as create_ssr_component, e as escape } from "./ssr.js";
const Avatar = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { associate } = $$props;
  let { size = "md" } = $$props;
  let { bgColor = "bg-neutral-500" } = $$props;
  let sizes = {
    sm: "h-7 w-7",
    md: "h-10 w-10",
    lg: "h-12 w-12",
    xl: "h-14 w-14",
    "2xl": "h-16 w-16"
  };
  let fontMapping = {
    sm: "text-xs",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl"
  };
  if ($$props.associate === void 0 && $$bindings.associate && associate !== void 0) $$bindings.associate(associate);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.bgColor === void 0 && $$bindings.bgColor && bgColor !== void 0) $$bindings.bgColor(bgColor);
  return `${associate ? `<div class="relative"><span class="${"inline-flex " + escape(sizes[size], true) + " items-center justify-center rounded-full " + escape(associate.isSignatory ? "bg-primary-500" : bgColor, true) + " ring-1 ring-primary-300"}"><span class="${"font-medium " + escape(fontMapping[size], true) + " leading-none text-white"}">${escape(associate?.firstName[0] + associate?.lastName[0])}</span></span>  <div class="${escape("hidden", true) + " ring ring-primary-300 absolute left-2 -bottom-5 whitespace-nowrap px-2 py-0.5 bg-white rounded text-neutral-500 z-20"}">${escape(associate.firstName)} ${escape(associate.lastName)}</div></div>` : ``}`;
});
export {
  Avatar as A
};
//# sourceMappingURL=Avatar.js.map
